import React from "react";

export default function TextSection({ data }: { data: string }) {
  return (
    <div style={{ marginBottom: "24px", lineHeight: "25px" }}>
      {(data.split("\n") || []).map((context: string, index: number) => {
        const lines = context.split("\n");
        return (lines || [])?.map((_line: string, index: number) => (
          <div
            key={index}
            style={{
              lineHeight: "25px",
            }}
          >
            {_line}
            <br />
          </div>
        ));
      })}
    </div>
  );
}
